<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
    <div class="save-panel">
      <button class="btn btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ "save" | setText("Сохранить") }}
      </button>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "lessonplans",
    cardSetLink: "lessonplans",
    item: null,
    fields: [
      {
        col: "col-12 col-md-4",
        key: "position",
        label: "Номер темы",
        type: "field",
        textType: "number",
      },
      {
        col: "col-12 col-md-8",
        key: "name",
        label: "Название темы",
        type: "field",
        textType: "text",
      },

      {
        label: "Предмет",
        key: "discipline",
        type: "select",
        selectKey: "title",
        modal: "discipline",
        prefix: "lessonplan_discipline",
      },
      {
        col: "col-12 col-md-6",
        key: "locale",
        label: "Локализация контента",
        type: "locale",
        textType: "text",
      },
      {
        col: "col-12 col-md-6",
        label: "Для классов",
        key: "course_id",
        type: "course",
        selectKey: "title",
      },
    ],
  }),
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
    },
  },
};
</script>
<style>
</style>
